import { createAction } from 'typesafe-actions'

export const globalSearchAction = createAction('GLOBAL_SEARCH')<
  string | undefined
>()
